module.exports = __webpack_public_path__ + "assets/img/add.683f547f.svg";